// @flow
import UserAbout from './UserAbout';

export default UserAbout;



// WEBPACK FOOTER //
// ./src/components/user/UserAbout/index.js